import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  skeletonWrapper: {
    paddingTop: "20px"
  },
  baseSkeleton: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
  },
  longBase: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "300px !important",
    },
  },
  firstPart: {
    display: "flex",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display: "grid",
    },
  },
  btnsDiv: {
    display: "flex",
    marginTop: "15px",
  },
  btnsSk: {
    marginLeft: "auto",
    "& .span": {
      display: "flex",
    },
    "& .react-loading-skeleton": {
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        width: "50px !important",
      },
    },
  },
  secondPart: {
    display: "flex",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      display: "grid",
    },
  },
  secondRow: {
    marginLeft: "80px",
    [`@media (max-width: ${breakpoints.xl}px)`]: {
      marginLeft: "0",
    },
  },
  shortSk: {
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
  },
  longSk: {
    paddingBottom: "8px",
    marginBottom: "20px",
    backgroundColor: colors.darkGrey,
    "--base-color": colors.darkGrey,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "350px !important",
    },
  },
  border: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: "20px 0px",
  },
});

export default styles;
